var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header-wrapper"}},[_vm._m(0),_c('div',{attrs:{"id":"header-actions-wrapper"}},[_c('div',{attrs:{"id":"btn-side-menu-toggle"},on:{"click":_vm.toggleSideMenu}},[_c('fa',{staticClass:"fa-lg",attrs:{"icon":"bars"}})],1),_c('div',{attrs:{"id":"header-side-actions"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header-side-wrapper"}},[_c('div',{attrs:{"id":"logo-wrapper"}})])
}]

export { render, staticRenderFns }